/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const mutateBodyAddFilesItemClientIdMax = 36;

export const mutateBodyAddFilesItemClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateBodyAddFilesMax = 200;

export const mutateBodyAddNodesItemClientIdMax = 36;

export const mutateBodyAddNodesItemClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateBodyAddNodesItemContentTypeClientIdMax = 36;

export const mutateBodyAddNodesItemContentTypeClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');

export const mutateBodyAddNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const mutateBodyAddNodesItemTypeDefinitionReferenceViewPredicatesMax = 10;

export const mutateBodyAddNodesItemTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const mutateBodyAddNodesItemTypeDefinitionReferenceViewSearchTermsMax = 10;

export const mutateBodyAddNodesItemTypeNameMax = 200;

export const mutateBodyAddNodesMax = 1000;

export const mutateBodyEditNodesItemExpectedOutgoingRevisionMax = 128;

export const mutateBodyEditNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const mutateBodyEditNodesItemTypeDefinitionReferenceViewPredicatesMax = 10;

export const mutateBodyEditNodesItemTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const mutateBodyEditNodesItemTypeDefinitionReferenceViewSearchTermsMax = 10;

export const mutateBodyEditNodesItemTypeNameMax = 200;

export const mutateBodyEditNodesMax = 1000;

export const mutateBodyRemoveEdgesItemEdgeKeyMax = 200;

export const mutateBodyRemoveEdgesItemExpectedOutgoingRevisionMax = 128;

export const mutateBodyRemoveEdgesMax = 1000;

export const mutateBodyRootsItemClientIdMax = 36;

export const mutateBodyRootsItemClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateBodyRootsItemNameMax = 100;

export const mutateBodyRootsMax = 50;

export const mutateBodySetEdgesItemEdgeDescriptionMax = 2000;

export const mutateBodySetEdgesItemEdgeKeyMax = 200;

export const mutateBodySetEdgesItemExpectedOutgoingRevisionMax = 128;

export const mutateBodySetEdgesItemFromClientIdMax = 36;

export const mutateBodySetEdgesItemFromClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateBodySetEdgesItemMaxCountMin = 0;

export const mutateBodySetEdgesItemMinCountMin = 0;

export const mutateBodySetEdgesItemToClientIdMax = 36;

export const mutateBodySetEdgesItemToClientIdRegExp = new RegExp('^[a-z0-9._:-]+$');
export const mutateBodySetEdgesMax = 2000;

export const MutateBody = zod.object({
  addFiles: zod
    .array(
      zod.object({
        clientId: zod
          .string()
          .min(1)
          .max(mutateBodyAddFilesItemClientIdMax)
          .regex(mutateBodyAddFilesItemClientIdRegExp)
          .describe(
            'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
          ),
        fileUuid: zod.uuid().describe('UUID v4 identifier'),
        occurredAt: zod.iso.datetime({ offset: true }).optional(),
        subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
      }),
    )
    .max(mutateBodyAddFilesMax)
    .optional(),
  addNodes: zod
    .array(
      zod.object({
        clientId: zod
          .string()
          .min(1)
          .max(mutateBodyAddNodesItemClientIdMax)
          .regex(mutateBodyAddNodesItemClientIdRegExp)
          .describe(
            'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
          ),
        contentTypeClientId: zod
          .string()
          .min(1)
          .max(mutateBodyAddNodesItemContentTypeClientIdMax)
          .regex(mutateBodyAddNodesItemContentTypeClientIdRegExp)
          .optional()
          .describe(
            'An INSTANCE’s TYPE added in THIS request. XOR with `contentTypeUuid`. Not accepted on a TYPE node.',
          ),
        contentTypeUuid: zod
          .uuid()
          .optional()
          .describe(
            'For an INSTANCE, the TYPE it instantiates (XOR with `contentTypeClientId`). For a TYPE, an optional grouping parent — which must already exist.',
          ),
        occurredAt: zod.iso.datetime({ offset: true }).optional(),
        subjectUuid: zod.uuid().nullish().describe('UUID v4 identifier'),
        typeDefinition: zod
          .object({
            conformance: zod
              .enum(['open', 'lax', 'strict'])
              .optional()
              .describe(
                'open enforces slots and allows extra bodies; strict additionally rejects extra bodies; lax admits slot violations and reports them in audit. Omission preserves the stored declaration; null cannot clear it.',
              ),
            description: zod.string().nullish(),
            enums: zod
              .array(
                zod.object({
                  label: zod.string(),
                  value: zod.string(),
                }),
              )
              .nullish()
              .describe(
                'Ordered ENUM choices as { value, label } pairs. Both are preserved; this contract does not collapse a label into its value.',
              ),
            file: zod
              .object({
                allowedFormats: zod
                  .array(
                    zod.enum([
                      'pdf',
                      'doc',
                      'docx',
                      'xls',
                      'xlsx',
                      'csv',
                      'txt',
                      'jpeg',
                      'png',
                      'webp',
                      'gif',
                      'heic',
                      'md',
                      'html',
                      'mp3',
                      'm4a',
                      'wav',
                      'mp4',
                      'mov',
                      'webm',
                    ]),
                  )
                  .min(1)
                  .optional(),
              })
              .nullish(),
            metadata: zod
              .record(zod.string(), zod.unknown())
              .nullish()
              .describe(
                'Arbitrary authored metadata. Its keys are content, not command fields, and are stored and returned unaltered.',
              ),
            reference: zod
              .object({
                carbonCopy: zod.boolean().optional(),
                creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
                edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
                typeLineageUuid: zod.uuid(),
                typeUuid: zod.uuid(),
                view: zod
                  .object({
                    predicates: zod
                      .array(
                        zod.object({
                          op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                          pathTypeUuids: zod
                            .array(zod.uuid())
                            .min(1)
                            .max(
                              mutateBodyAddNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax,
                            ),
                          value: zod.string().optional(),
                          valueType: zod
                            .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                            .optional(),
                        }),
                      )
                      .max(mutateBodyAddNodesItemTypeDefinitionReferenceViewPredicatesMax)
                      .optional(),
                    searchTerms: zod
                      .array(
                        zod
                          .string()
                          .min(1)
                          .max(mutateBodyAddNodesItemTypeDefinitionReferenceViewSearchTermsItemMax),
                      )
                      .max(mutateBodyAddNodesItemTypeDefinitionReferenceViewSearchTermsMax)
                      .optional(),
                  })
                  .nullish(),
              })
              .nullish(),
            signature: zod.looseObject({}).nullish(),
          })
          .optional(),
        typeName: zod
          .string()
          .min(1)
          .max(mutateBodyAddNodesItemTypeNameMax)
          .optional()
          .describe('Required for variant TYPE; rejected for INSTANCE.'),
        value: zod
          .object({
            booleanValue: zod.boolean().nullish(),
            dateValue: zod.string().nullish(),
            datetimeValue: zod.string().nullish(),
            jsonValue: zod.unknown().optional(),
            numericValue: zod.number().nullish(),
            stringValue: zod.string().nullish(),
          })
          .optional(),
        valueType: zod
          .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME', 'ENUM', 'JSON'])
          .optional(),
        variant: zod
          .enum(['TYPE', 'INSTANCE'])
          .describe(
            'Explicit, never inferred. A TYPE authors schema; an INSTANCE holds authored data.',
          ),
      }),
    )
    .max(mutateBodyAddNodesMax)
    .optional(),
  editNodes: zod
    .array(
      zod.object({
        contentUuid: zod
          .uuid()
          .describe(
            'The exact version being edited, as returned by GET. A stale version is a 409, not a silent replacement.',
          ),
        expectedOutgoingRevision: zod
          .string()
          .min(1)
          .max(mutateBodyEditNodesItemExpectedOutgoingRevisionMax)
          .optional()
          .describe(
            'Opaque revision of a source node’s outgoing edges and TYPE policy state, as returned by GET \/content\/{lineageUuid}. Supplied here it is a precondition: the write is refused with 409 if the source has changed since. A node UUID alone is insufficient — an edge-only change does not version its source.',
          ),
        occurredAt: zod.iso.datetime({ offset: true }).optional(),
        subjectUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        typeDefinition: zod
          .object({
            conformance: zod
              .enum(['open', 'lax', 'strict'])
              .optional()
              .describe(
                'open enforces slots and allows extra bodies; strict additionally rejects extra bodies; lax admits slot violations and reports them in audit. Omission preserves the stored declaration; null cannot clear it.',
              ),
            description: zod.string().nullish(),
            enums: zod
              .array(
                zod.object({
                  label: zod.string(),
                  value: zod.string(),
                }),
              )
              .nullish()
              .describe(
                'Ordered ENUM choices as { value, label } pairs. Both are preserved; this contract does not collapse a label into its value.',
              ),
            file: zod
              .object({
                allowedFormats: zod
                  .array(
                    zod.enum([
                      'pdf',
                      'doc',
                      'docx',
                      'xls',
                      'xlsx',
                      'csv',
                      'txt',
                      'jpeg',
                      'png',
                      'webp',
                      'gif',
                      'heic',
                      'md',
                      'html',
                      'mp3',
                      'm4a',
                      'wav',
                      'mp4',
                      'mov',
                      'webm',
                    ]),
                  )
                  .min(1)
                  .optional(),
              })
              .nullish(),
            metadata: zod
              .record(zod.string(), zod.unknown())
              .nullish()
              .describe(
                'Arbitrary authored metadata. Its keys are content, not command fields, and are stored and returned unaltered.',
              ),
            reference: zod
              .object({
                carbonCopy: zod.boolean().optional(),
                creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
                edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
                typeLineageUuid: zod.uuid(),
                typeUuid: zod.uuid(),
                view: zod
                  .object({
                    predicates: zod
                      .array(
                        zod.object({
                          op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                          pathTypeUuids: zod
                            .array(zod.uuid())
                            .min(1)
                            .max(
                              mutateBodyEditNodesItemTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax,
                            ),
                          value: zod.string().optional(),
                          valueType: zod
                            .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                            .optional(),
                        }),
                      )
                      .max(mutateBodyEditNodesItemTypeDefinitionReferenceViewPredicatesMax)
                      .optional(),
                    searchTerms: zod
                      .array(
                        zod
                          .string()
                          .min(1)
                          .max(
                            mutateBodyEditNodesItemTypeDefinitionReferenceViewSearchTermsItemMax,
                          ),
                      )
                      .max(mutateBodyEditNodesItemTypeDefinitionReferenceViewSearchTermsMax)
                      .optional(),
                  })
                  .nullish(),
              })
              .nullish(),
            signature: zod.looseObject({}).nullish(),
          })
          .optional(),
        typeName: zod
          .string()
          .min(1)
          .max(mutateBodyEditNodesItemTypeNameMax)
          .optional()
          .describe('Rename a TYPE. Rejected on an INSTANCE.'),
        value: zod
          .object({
            booleanValue: zod.boolean().nullish(),
            dateValue: zod.string().nullish(),
            datetimeValue: zod.string().nullish(),
            jsonValue: zod.unknown().optional(),
            numericValue: zod.number().nullish(),
            stringValue: zod.string().nullish(),
          })
          .optional(),
        variant: zod
          .enum(['TYPE', 'INSTANCE'])
          .describe(
            'Asserted stored variant. Verified against storage; a mismatch is a 409. This is not a conversion request.',
          ),
      }),
    )
    .max(mutateBodyEditNodesMax)
    .optional(),
  idempotencyKey: zod
    .uuid()
    .describe(
      'Caller-generated, required. Same key + same command returns the stored receipt instead of writing twice; same key + a DIFFERENT command is a 409. Reuse it verbatim when retrying.',
    ),
  performAs: zod
    .object({
      actorUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      principalType: zod.enum(['USER', 'GROUP', 'GROUP_MEMBER']),
    })
    .optional(),
  removeEdges: zod
    .array(
      zod.object({
        edgeKey: zod
          .string()
          .max(mutateBodyRemoveEdgesItemEdgeKeyMax)
          .nullable()
          .describe(
            'The slot key you expect this edge to carry, or null for an edge you expect to be unkeyed. Checked, not ignored.',
          ),
        edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
        expectedOutgoingRevision: zod
          .string()
          .min(1)
          .max(mutateBodyRemoveEdgesItemExpectedOutgoingRevisionMax)
          .optional()
          .describe(
            'Opaque revision of a source node’s outgoing edges and TYPE policy state, as returned by GET \/content\/{lineageUuid}. Supplied here it is a precondition: the write is refused with 409 if the source has changed since. A node UUID alone is insufficient — an edge-only change does not version its source.',
          ),
        fromContentUuid: zod.uuid().describe('UUID v4 identifier'),
        toContentUuid: zod.uuid().describe('UUID v4 identifier'),
      }),
    )
    .max(mutateBodyRemoveEdgesMax)
    .optional(),
  roots: zod
    .array(
      zod.object({
        clientId: zod
          .string()
          .min(1)
          .max(mutateBodyRootsItemClientIdMax)
          .regex(mutateBodyRootsItemClientIdRegExp)
          .optional()
          .describe(
            'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
          ),
        contentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        name: zod
          .string()
          .min(1)
          .max(mutateBodyRootsItemNameMax)
          .describe(
            'Caller’s label for this root, echoed in the response so a batch with several roots can be reattached without positional guessing.',
          ),
      }),
    )
    .max(mutateBodyRootsMax)
    .optional(),
  setEdges: zod
    .array(
      zod.object({
        carbonCopy: zod.boolean().optional(),
        certainty: zod.enum(['ASSERTED', 'INFERRED', 'SUGGESTED']).optional(),
        edgeDescription: zod
          .string()
          .max(mutateBodySetEdgesItemEdgeDescriptionMax)
          .nullish()
          .describe(
            'Authored edge text. An explicit empty string is a value and is stored; descriptions never define edge identity.',
          ),
        edgeKey: zod
          .string()
          .max(mutateBodySetEdgesItemEdgeKeyMax)
          .nullish()
          .describe(
            'Schema slot key on a TYPE→TYPE declaration: lower snake_case, unique per source TYPE across CONTAINS and INCLUDES. Preserved across a target rename or reorder — never re-derived from a changed type name. Omission preserves the stored key; null clears it. INSTANCE CONTAINS role keys use lower snake_case. Omission preserves an existing role or creates an unkeyed edge.',
          ),
        edgeType: zod.enum(['CONTAINS', 'RELATES_TO', 'INCLUDES']),
        expectedOutgoingRevision: zod
          .string()
          .min(1)
          .max(mutateBodySetEdgesItemExpectedOutgoingRevisionMax)
          .optional()
          .describe(
            'Opaque revision of a source node’s outgoing edges and TYPE policy state, as returned by GET \/content\/{lineageUuid}. Supplied here it is a precondition: the write is refused with 409 if the source has changed since. A node UUID alone is insufficient — an edge-only change does not version its source.',
          ),
        fromClientId: zod
          .string()
          .min(1)
          .max(mutateBodySetEdgesItemFromClientIdMax)
          .regex(mutateBodySetEdgesItemFromClientIdRegExp)
          .optional()
          .describe(
            'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
          ),
        fromContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
        maxCount: zod.int().min(mutateBodySetEdgesItemMaxCountMin).nullish(),
        minCount: zod.int().min(mutateBodySetEdgesItemMinCountMin).nullish(),
        position: zod.int().nullish(),
        toClientId: zod
          .string()
          .min(1)
          .max(mutateBodySetEdgesItemToClientIdMax)
          .regex(mutateBodySetEdgesItemToClientIdRegExp)
          .optional()
          .describe(
            'Caller-supplied reference for a node added in THIS request, unique within it. Wires edges to not-yet-persisted nodes and keys the response’s clientIdMap. Lowercase letters, numbers, and ._:- only.',
          ),
        toContentUuid: zod.uuid().optional().describe('UUID v4 identifier'),
      }),
    )
    .max(mutateBodySetEdgesMax)
    .optional(),
});

export type MutateBody = zod.input<typeof MutateBody>;
export type MutateBodyOutput = zod.output<typeof MutateBody>;
